var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 468.7 468.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1963_",
    d: "M334.6,115.6l-5.1-21.8c-6.5-27.7-31.2-47.3-59.6-47.3h-71.3c-28.5,0-53.2,19.6-59.6,47.3l-5.1,21.8 C50.4,130,0,156.6,0,156.6v163.6c0,56.3,45.7,102,102,102h264.7c56.3,0,102-45.7,102-102V156.6 C468.5,156.6,418.1,130.1,334.6,115.6z M69.8,213.5c-10.1,0-18.2-8.2-18.2-18.2c0-10.1,8.2-18.2,18.2-18.2S88,185.3,88,195.3 C88,205.3,79.9,213.5,69.8,213.5z M234.2,378.4c-61.2,0-110.9-49.6-110.9-110.9S173,156.6,234.2,156.6s110.9,49.6,110.9,110.9 S295.4,378.4,234.2,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1914_",
    d: "M234.2,188.2c-43.8,0-79.3,35.5-79.3,79.3s35.5,79.3,79.3,79.3s79.3-35.5,79.3-79.3 S278,188.2,234.2,188.2z M234.2,241.7c-14.2,0-25.8,11.6-25.8,25.8c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8 c0-27.3,22.2-49.5,49.5-49.5c6.5,0,11.8,5.3,11.8,11.8S240.7,241.7,234.2,241.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCameraIcon);
export default __webpack_public_path__ + "static/media/photo-camera-icon.5747cbb1.svg";
export { ForwardRef as ReactComponent };